"use client";
import { Obituary } from "@/services/Obituary";
import { TObituaryBook, TObituaryFull } from "@/types/obituary";
import { getStyle } from "@/utils/styles";
import { useEffect, useState } from "react";
import AddCommentForm from "./AddCommentForm";
import Comment from "./Comment";

import { Loader2 } from "lucide-react";
import { useIntersectionObserver } from "usehooks-ts";

const BookComponent = (props: TObituaryFull) => {
  let { slug } = props;
  const [page, setPage] = useState<number>(1);
  const [initialLoad, setInitialLoad] = useState<boolean>(false);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [book, setBook] = useState<TObituaryBook>({});
  const { isIntersecting, ref } = useIntersectionObserver({
    threshold: 0.5,
  });

  useEffect(() => {
    if (isIntersecting && !isLoading && initialLoad) {
      loadNext();
    }
  }, [isIntersecting]);

  const loadBook = async () => {
    // setPage(0);
    firstLoad();
  };

  useEffect(() => {
    firstLoad();
  }, []);

  const loadNext = async () => {
    console.log(page, totalPages);
    if (page >= totalPages) return;
    setIsLoading(true);
    let _book: TObituaryBook = await Obituary.getObituaryBookPage(
      slug,
      page + 1
    );
    setBook({ ...book, comments: [...book.comments!, ..._book.comments!] });
    setIsLoading(false);
    setPage(page + 1);
  };

  const firstLoad = async () => {
    setIsLoading(true);
    setBook({});
    let _book: TObituaryBook = await Obituary.getObituaryBookPage(slug, page);
    setBook(_book);
    setTotalPages(_book.page?.totalPages || 0);
    setInitialLoad(true);
    setIsLoading(false);
    setPage(1);
  };

  if (!initialLoad) return <></>;

  return (
    <section
      className={` flex h-auto
w-full flex-col items-center !bg-white ${getStyle("whiteSecondary").bg} ${
        getStyle("whiteSecondary").text
      }`}
      id={"book"}
    >
      <div
        className={`container flex h-full w-full flex-col items-center gap-4 px-4 py-16 `}
      >
        <div className="flex flex-col ">
          <h2 className="mx-auto text-center text-3xl lg:text-5xl">
            Kondolenzbuch
          </h2>
          <p className="text-center text-lg ">
            {book.page?.totalElements === 0
              ? "Hinterlassen Sie die erste Nachricht"
              : book.page?.totalElements === 1
              ? "1 Kondolenz"
              : `${book.page?.totalElements} Kondolenzen`}
          </p>
        </div>
        <AddCommentForm {...props} loadBook={loadBook} />
        <div
          id="initBook"
          className=" flex h-full w-full flex-col items-center gap-8 px-4 py-8"
        >
          {book.comments &&
            book.comments.map((item) => (
              <Comment {...item} key={item.uuid} loadBook={loadBook} />
            ))}
          {isLoading && (
            <div className="flex w-full flex-row p-2">
              <span className="mx-auto flex flex-row items-center justify-center gap-2 rounded-lg rounded-xl bg-black-500 px-2 py-1 font-bold text-white">
                <Loader2 className="duration-500/ h-4 w-4 animate-spin" />
                <p>Kondolenzen werden geladen</p>
              </span>
            </div>
          )}
        </div>
      </div>

      {page < totalPages && <div ref={ref} />}
    </section>
  );
};

export default BookComponent;
